import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

function HomeComponent() {
  const { isAuthenticated } = useContext(AuthContext);

  return (
    <>
      {/* Features Section */}
      <div className="features-grid">
        {/* Search Feature */}
        <div className="feature-card">
          <div className="feature-icon">
            <i className="fas fa-search-dollar"></i>
          </div>
          <h3>Erweiterte Aktiensuche</h3>
          <p>Filtere Aktien nach verschiedenen Kriterien wie Dividenden, KGV, Branche und Wachstumsprognosen.</p>
          <Link to="/search" className="feature-link">
            Aktiensuche starten
            <i className="fas fa-arrow-right"></i>
          </Link>
        </div>

        {/* Portfolio Feature */}
        <div className="feature-card">
          <div className="feature-icon">
            <i className="fas fa-chart-line"></i>
          </div>
          <h3>Portfolio-Verwaltung</h3>
          <p>Erstelle und verwalte deine persönliche Watchlist. Verfolge die Performance und erhalte Einblicke in ausgewählten Aktien.</p>
          {isAuthenticated ? (
            <Link to="/watchlist" className="feature-link">
              Zur Watchlist
              <i className="fas fa-arrow-right"></i>
            </Link>
          ) : (
            <Link to="/login" className="feature-link">
              Jetzt anmelden
              <i className="fas fa-arrow-right"></i>
            </Link>
          )}
        </div>

        {/* Analysis Feature */}
        <div className="feature-card">
          <div className="feature-icon">
            <i className="fas fa-analytics"></i>
          </div>
          <h3>Detaillierte Analyse</h3>
          <p>Zugriff auf umfassende Finanzkennzahlen, Wachstumsprognosen und fundamentale Daten für fundierte Anlageentscheidungen.</p>
          <Link to="/search" className="feature-link">
            Kennzahlen erkunden
            <i className="fas fa-arrow-right"></i>
          </Link>
        </div>
      </div>

      {/* CTA Section */}
      <div className="cta-content">
        <h2>Bereit für smarte Investitionen?</h2>
        <p>Nutze unsere Plattform für deine Investmentrecherche.</p>
        {isAuthenticated ? (
          <Link to="/search" className="primary-button">
            <i className="fas fa-search"></i>
            Suche starten
          </Link>
        ) : (
          <div className="cta-buttons">
            <Link to="/register" className="primary-button">
              <i className="fas fa-user-plus"></i>
              Kostenloses Konto erstellen
            </Link>
            <Link to="/login" className="text-button">
              Bereits registriert? Hier anmelden
            </Link>
          </div>
        )}
      </div>
    </>
  );
}

export default HomeComponent;